import React, { useEffect, useRef, memo } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const StageLighting = memo(() => {
  const lightsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const lights = lightsRef.current;
      
      // Simplified zones to reduce ScrollTrigger overhead
      const zones = [
        { start: 0, end: 20, color: "rgba(0,209,255,0.2)", scale: 1.2 },
        { start: 20, end: 40, color: "rgba(34,197,94,0.1)", scale: 1.1 },
        { start: 40, end: 60, color: "rgba(255,255,255,0.3)", scale: 1.5 },
        { start: 60, end: 100, color: "rgba(0,209,255,0.1)", scale: 1.0 },
      ];

      zones.forEach((zone) => {
        ScrollTrigger.create({
          trigger: "body",
          start: `${zone.start}% top`,
          end: `${zone.end}% top`,
          onToggle: (self) => {
            if (self.isActive) {
              gsap.to(lights, {
                backgroundColor: zone.color,
                scale: zone.scale,
                duration: 1,
                ease: "power2.inOut",
                overwrite: 'auto'
              });
            }
          },
        });
      });

      // Simplified movement to reduce CPU usage
      lights.forEach((light, i) => {
        gsap.to(light, {
          x: "random(-50, 50)",
          y: "random(-50, 50)",
          duration: 4 + i,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
        });
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden bg-studio-black">
      {[...Array(3)].map((_, i) => (
        <div 
          key={i} 
          ref={(el) => (lightsRef.current[i] = el)} 
          className="absolute w-[500px] h-[500px] rounded-full blur-[100px] opacity-20 will-change-transform" 
          style={{ 
            top: i === 0 ? '-10%' : i === 1 ? '40%' : '70%', 
            left: i === 0 ? '10%' : i === 1 ? '60%' : '20%',
            backgroundColor: 'rgba(0,209,255,0.3)' 
          }} 
        />
      ))}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 mix-blend-overlay" />
    </div>
  );
});

export default StageLighting;